module.exports = __webpack_public_path__ + "media/images/icons/hourglass-4d2d5bba2e8974c5b717604716a3ad4b.svg";